import account from './account/vi-VN.json';
import affiliate from './affiliate/vi-VN.json';
import component from './component/vi-VN.json';
import menus from './menus/vi-VN.json';
import user from './users/vi-VN.json';
import global from './global/vi-VN.json';
import support from './support/vi-VN.json';
import result from './result/vi-VN.json';
import finance from './finance/vi-VN.json';
import region from './region/vi-VN.json';
import request from './request/vi-VN.json';

const titleMenu = Object.entries(menus).reduce((pre: object, [key, value]: [string, string]) => {
  // 添加统一后缀
  return {
    ...pre,
    [`title.${key}`]: `${value} - LightNode`,
  };
}, {});

export default {
  ...account,
  ...affiliate,
  ...component,
  ...menus,
  ...titleMenu,
  ...user,
  ...global,
  ...support,
  ...result,
  ...finance,
  ...region,
  ...request,
};
